import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueSignaturePad from 'vue-signature-pad'
import '@/styles/ai-theme.css'
import { formatPhone } from '@/phone'
import { teamLabel } from '@/scoreboard'

const app = createApp(App);
app.use(VueSignaturePad);
app.config.globalProperties.convertVideoEmbedLink = (link: string) => {
    if(link.includes('youtube.com') && link.includes('watch?v=')) {
        return link.replace('watch?v=', 'embed/');
    } else if(link.includes('youtu.be')) {
        const start = link.indexOf('.be/');
        const end = link.indexOf('?');
        const id = link.substring(start + 4, end);
        return `https://youtube.com/embed/` + id;
    } else if(link.includes('vimeo.com')) {
        const linkSplit = link.split('/');
        const lastSection = linkSplit[linkSplit.length - 1];
        const id = lastSection.split('?')[0];
        return 'https://player.vimeo.com/video/' + id;
    } else {
        return link;
    }
}
// Display-only: US / Canada as (123) 444-5555, other countries in international format.
// Anything that isn't a valid number is returned unchanged
app.config.globalProperties.formatPhone = formatPhone;
app.config.globalProperties.teamLabel = teamLabel;
app.config.globalProperties.stripHtml = (string: string) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(string, 'text/html');
    return doc.body.textContent || '';
}
app.config.globalProperties.doubleScroll = (element: any) => {
    const prevScrollBars = document.querySelectorAll('.double-scroll-bar');
    for(const scrollBar of prevScrollBars) {
        scrollBar.remove();
    }
    const scrollbar = document.createElement("div") as any;
    scrollbar.className = 'double-scroll-bar';
    scrollbar.appendChild(document.createElement("div"));
    scrollbar.style.overflow = "auto";
    scrollbar.style.overflowY = "hidden";
    scrollbar.firstChild.style.width = element.scrollWidth + "px";
    scrollbar.firstChild.style.paddingTop = "1px";
    scrollbar.firstChild.appendChild(document.createTextNode("\xA0"));
    let running = false;
    // Keep scrollbar in sync when element size changes
    new ResizeObserver(() => {
        scrollbar.firstChild.style.width = element.scrollWidth + "px";
    }).observe(element);
    scrollbar.onscroll = function () {
        if (running) {
            running = false;
            return;
        }
        running = true;
        element.scrollLeft = scrollbar.scrollLeft;
    };
    element.onscroll = function () {
        if (running) {
            running = false;
            return;
        }
        running = true;
        scrollbar.scrollLeft = element.scrollLeft;
    };
    element.parentNode.insertBefore(scrollbar, element);
}
app.config.globalProperties.isTouchDevice = () => {
    return (('ontouchstart' in window) || (navigator.maxTouchPoints > 0));
}
app.use(store);
app.use(router);
app.mount('#app')
